import { DISTRIBUTION_MODES } from 'src/consts';

// 判断餐厅网站设置页是否可见
export function checkOnlineOrderingSettingVisible(restaurantInfo) {
  const { restaurant_contracts } = restaurantInfo;
  // 判断是否开了white_label合约，并且为v2
  return (restaurant_contracts || []).some(
    (item) => item['online_ordering_version'] === 'v2' && item.distribution_mode === DISTRIBUTION_MODES.WHITE_LABEL
  );
}

// 设置打款报表也是否可见
export function checkPayoutReportVisible(restaurantInfo) {
  const { restaurant_contracts } = restaurantInfo;
  // 判断pos contract 的cost_plus_start_at 字段是否不为空
  return (
    (restaurant_contracts || []).findIndex(
      (item) => item.distribution_mode === DISTRIBUTION_MODES.POS && !!item.cost_plus_start_at
    ) > -1
  );
}
